import _classCallCheck from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\project\\reactjs\\event\\BPMN\\penalty\\TamQuocChi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { attachProps, createForwardRef, dashToPascalCase, isCoveredByReact, mergeRefs } from './utils';
export var createReactComponent = function createReactComponent(tagName, ReactComponentContext, manipulatePropsFunction) {
  var displayName = dashToPascalCase(tagName);

  var ReactComponent = /*#__PURE__*/function (_React$Component) {
    _inherits(ReactComponent, _React$Component);

    var _super = _createSuper(ReactComponent);

    function ReactComponent(props) {
      var _this;

      _classCallCheck(this, ReactComponent);

      _this = _super.call(this, props);

      _this.setComponentElRef = function (element) {
        _this.componentEl = element;
      };

      return _this;
    }

    _createClass(ReactComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate(this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        attachProps(this.componentEl, this.props, prevProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _a = this.props,
            children = _a.children,
            forwardedRef = _a.forwardedRef,
            style = _a.style,
            className = _a.className,
            ref = _a.ref,
            cProps = __rest(_a, ["children", "forwardedRef", "style", "className", "ref"]);

        var propsToPass = Object.keys(cProps).reduce(function (acc, name) {
          if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
            var eventName = name.substring(2).toLowerCase();

            if (typeof document !== 'undefined' && isCoveredByReact(eventName, document)) {
              acc[name] = cProps[name];
            }
          } else {
            acc[name] = cProps[name];
          }

          return acc;
        }, {});

        if (manipulatePropsFunction) {
          propsToPass = manipulatePropsFunction(this.props, propsToPass);
        }

        var newProps = Object.assign(Object.assign({}, propsToPass), {
          ref: mergeRefs(forwardedRef, this.setComponentElRef),
          style: style
        });
        return React.createElement(tagName, newProps, children);
      }
    }], [{
      key: "displayName",
      get: function get() {
        return displayName;
      }
    }]);

    return ReactComponent;
  }(React.Component); // If context was passed to createReactComponent then conditionally add it to the Component Class


  if (ReactComponentContext) {
    ReactComponent.contextType = ReactComponentContext;
  }

  return createForwardRef(ReactComponent, displayName);
};